/**
 * Header search overlay: opens when the search icon is clicked.
 * Closes on close button, backdrop click, or Escape key.
 */
export function initSearch() {
  const trigger = document.querySelector("[data-search-trigger]");
  const search = document.getElementById("site-search");
  const closeButtons = document.querySelectorAll("[data-search-close]");
  const input = document.getElementById("site-search-input");

  if (!trigger || !search) return;

  function open() {
    search.classList.add("is-open");
    search.setAttribute("aria-hidden", "false");
    trigger.setAttribute("aria-expanded", "true");
    trigger.setAttribute("aria-label", "Close search");
    if (input) {
      setTimeout(() => input.focus(), 100);
    }
  }

  function close() {
    search.classList.remove("is-open");
    search.setAttribute("aria-hidden", "true");
    trigger.setAttribute("aria-expanded", "false");
    trigger.setAttribute("aria-label", "Open search");
    if (input) input.value = "";
  }

  function toggle() {
    search.classList.contains("is-open") ? close() : open();
  }

  trigger.addEventListener("click", toggle);

  closeButtons.forEach((btn) => btn.addEventListener("click", close));

  search.querySelectorAll(".site-header__search-suggestion-link").forEach((link) => {
    link.addEventListener("click", close);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && search.classList.contains("is-open")) close();
  });
}
